import { combineReducers } from 'redux';

import userCompanies from '@web-shared/reducers/user-companies';

export default combineReducers({ userCompanies });

